module.exports = __webpack_public_path__ + "video/1100_1_HC_2023_Malicious_Apps.a19f5c9e.vtt";